// development.tsx
import React, { Fragment } from "react";
import { Link } from "react-router-dom";

import img13 from "../../../images/service/web3.png";
import iconPlaceholder from "../../../images/service/web3.png";

import Header from "../../../components/Header/Header";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Scrollbar from "../../../components/scrollbar/scrollbar";
import Footer from "../../../components/footer/Footer";
import GallerySection from "../../SeviceSinglePage/GallerySection";
import BrandSection from "../../../components/FeatureSection/BrandSection";
import serviceImg from "../../../images/icon/feature-icon03.svg";


import feature1 from "../../../images/icon/feature-icon01.svg";
import feature2 from "../../../images/icon/feature-icon02.svg";
import feature3 from "../../../images/icon/feature-icon03.svg";
import feature4 from "../../../images/icon/blog-icon01.svg";

/**
 * development.tsx
 * A new creative Web3 Development page that mixes:
 *  - Premium agency layout (A)
 *  - Sci-Fi futuristic accents (B)
 *
 * Uses same theme classes (xb-*, wow, etc.) so it blends into your project.
 */

/* ---------------------------
   Content Data
   --------------------------- */
type Card = { title: string; content: string; accent?: string; icon?: string };

const heroBadges: Card[] = [
  { title: "Multi-Chain", content: "Ethereum | Polygon | Solana", accent: "neon-cyan", icon: feature1 },
  { title: "Security-First", content: "Audits, Formal Verification", accent: "neon-purple", icon: feature2 },
  { title: "Scalable Infra", content: "Layer-2 & Sidechains", accent: "neon-green", icon: feature3 },
];

const devServices: Card[] = [
  {
    title: "Custom Blockchain Engineering",
    content:
      "Design and run permissioned & permissionless blockchains with enterprise-grade consensus, telemetry and monitoring.",
    icon: feature1,
  },
  {
    title: "Smart Contract Systems",
    content:
      "Gas-optimized, modular contracts with upgradeability, role-based access control and on-chain governance primitives.",
    icon: feature2,
  },
  {
    title: "dApp UI & Wallet Integrations",
    content:
      "Sleek frontend experiences with React/Next + Ethers.js / Web3.js — MetaMask, WalletConnect, and mobile wallets supported.",
    icon: feature3,
  },
  {
    title: "Cross-Chain Bridges & Oracles",
    content:
      "Secure bridge architectures, oracle integrations and off-chain data pipelines for real-time interactions.",
    icon: feature4,
  },
  {
    title: "Token Engineering (FT & NFT)",
    content:
      "Tokenomics, minting rules, royalty mechanics, vesting and token migration paths for long-term viability.",
    icon: feature1,
  },
  {
    title: "DeFi Protocol Implementations",
    content:
      "AMMs, lending markets, yield engines and staking contracts built and stress-tested for production.",
    icon: feature2,
  },
];

export const techStack = [
  {
    title: "Layer1 Blockchains",
    icon: iconPlaceholder,
    items: [
      "Ethereum",
      "Bitcoin",
      "Polkadot",
      "Solana",
      "Binance Smart Chain",
      "Cardano",
      "Avalanche",
      "Tezos",
      "Algorand",
      "Cosmos",
      "Near",
      "Celo",
      "Fantom",
      "Aurora"
    ]
  },

  {
    title: "Layer 2 And Sidechains",
    icon: iconPlaceholder,
    items: [
      "Lightning Network (Bitcoin)",
      "Optimistic Rollups",
      "Plasma",
      "ZK Sync",
      "Starknet",
      "Polygon",
      "xDai Chain",
      "Arbitrum",
      "Loopring",
      "Raiden Network",
      "OMG Network",
      "Celer Network"
    ]
  },

  {
    title: "Token Standards",
    icon: iconPlaceholder,
    items: [
      "ERC-20 (Ethereum)",
      "ERC-721 (Non-fungible Tokens)",
      "ERC-1155",
      "BEP-20 (Binance Smart Chain)"
    ]
  },

  {
    title: "Infrastructure",
    icon: iconPlaceholder,
    items: [
      "AWS (Amazon Web Services)",
      "Google Cloud Platform",
      "Microsoft Azure",
      "Heroku",
      "DigitalOcean",
      "Docker",
      "Kubernetes"
    ]
  },

  {
    title: "Identity Management",
    icon: iconPlaceholder,
    items: [
      "Decentralized Identity (DID)",
      "Self-sovereign Identity (SSI)",
      "uPort",
      "Civic",
      "Sovrin"
    ]
  },

  {
    title: "Decentralized Storage",
    icon: iconPlaceholder,
    items: [
      "Inter Planetary File System",
      "Filecoin",
      "Arweave",
      "Skynet",
      "Sia",
      "Storj"
    ]
  },

  {
    title: "DeFi Protocols",
    icon: iconPlaceholder,
    items: [
      "Uniswap",
      "Compound",
      "Aave",
      "MakerDAO",
      "Yearn Finance",
      "Curve Finance"
    ]
  },

  {
    title: "Development Frameworks",
    icon: iconPlaceholder,
    items: [
      "Truffle",
      "Hardhat",
      "Embark",
      "Brownie",
      "Foundry",
      "Anchor"
    ]
  },

  {
    title: "Web3 Libraries",
    icon: iconPlaceholder,
    items: [
      "Web3.js",
      "Ethers.js",
      "Near.js",
      "Substrate (Polkadot ecosystem)"
    ]
  },

  {
    title: "Smart Contract Languages",
    icon: iconPlaceholder,
    items: [
      "Solidity",
      "Rust",
      "Vyper",
      "Cadence (Flow blockchain)"
    ]
  },

  {
    title: "Oracles",
    icon: iconPlaceholder,
    items: [
      "Chainlink",
      "Flusk",
      "Band Protocol",
      "Augur",
      "Tellor"
    ]
  },

  {
    title: "DAOs",
    icon: iconPlaceholder,
    items: [
      "DAOstack",
      "Aragon",
      "MolochDAO",
      "DAOhaus"
    ]
  },

  {
    title: "Testing Tools",
    icon: iconPlaceholder,
    items: [
      "Ganache",
      "Remix",
      "Hardhat",
      "Brownie"
    ]
  },

  {
    title: "Frontend Technologies",
    icon: iconPlaceholder,
    items: [
      "React",
      "Angular",
      "Vue.js",
      "Svelte"
    ]
  },

  {
    title: "Backend Technologies",
    icon: iconPlaceholder,
    items: [
      "Node.js",
      "Express.js",
      "Flask",
      "Django"
    ]
  },

  {
    title: "Database",
    icon: iconPlaceholder,
    items: [
      "MongoDB",
      "PostgreSQL",
      "SQLite",
      "Firebase"
    ]
  }
];


/* ---------------------------
   Component
   --------------------------- */

const Development: React.FC = () => {


  return (
    <Fragment>
      <div className="about-page inner-page">
        <div className="body_wrap o-clip">
          <Header />

          <main>
            <PageTitle pageTitle="Web 3.0 Development" pagesub="Premium blockchain & Web3 services" />

            {/* ================= HERO (Premium + Sci-fi mix) ================= */}
            <section
              className="hero-creative pos-rel"
              style={{
                padding: "70px 0 40px",
                background:
                  "linear-gradient(180deg, rgba(6,10,22,0.86) 0%, rgba(10,14,32,0.82) 100%), url(" +
                  img13 +
                  ") center/cover no-repeat",
                color: "white",
              }}
            >
              <div className="container">
                <div className="row align-items-center">
                  {/* LEFT - Headline & CTA */}
                  <div className="col-lg-7">
                    <div style={{ maxWidth: 720 }}>
                      <h1 className="xb-hero-title" style={{ fontSize: "42px", lineHeight: 1.04, marginBottom: 16 }}>
                        Build the future with secure, scalable Web3 systems
                      </h1>

                      <p className="xb-hero-lead" style={{ opacity: 0.9, marginBottom: 20 }}>
                        We design and ship production-grade blockchain ecosystems — tokenized products, DeFi protocols,
                        DAOs and enterprise blockchains — crafted for security, performance and real business outcomes.
                      </p>

                      <div style={{ display: "flex", gap: 12, alignItems: "center", marginBottom: 18 }}>
                        <Link className="thm-btn agency-btn megamenu-btn" to="/project">
                                                  <span className="text">Start Your Project</span>
                        
                                                  <span className="arrow">
                                                    <span className="arrow-icon">
                        
                                                      {/* FIRST 25px SVG */}
                                                      <svg
                                                        width="25"
                                                        height="25"
                                                        viewBox="0 0 25 25"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                      >
                                                        <rect
                                                          x="5.22852"
                                                          y="17.3296"
                                                          width="17.888"
                                                          height="2.27149"
                                                          transform="rotate(-40.2798 5.22852 17.3296)"
                                                          fill="white"
                                                        />
                                                        <rect
                                                          x="7.75781"
                                                          y="6.25635"
                                                          width="2.27149"
                                                          height="2.27149"
                                                          transform="rotate(-40.2798 7.75781 6.25635)"
                                                          fill="white"
                                                        />
                                                        <rect
                                                          x="10.959"
                                                          y="6.52002"
                                                          width="2.27149"
                                                          height="2.27149"
                                                          transform="rotate(-40.2798 10.959 6.52002)"
                                                          fill="white"
                                                        />
                                                        <rect
                                                          x="14.1562"
                                                          y="6.78516"
                                                          width="2.27149"
                                                          height="2.27149"
                                                          transform="rotate(-40.2798 14.1562 6.78516)"
                                                          fill="white"
                                                        />
                                                        <rect
                                                          x="17.0957"
                                                          y="10.25"
                                                          width="2.27149"
                                                          height="2.27149"
                                                          transform="rotate(-40.2798 17.0957 10.25)"
                                                          fill="white"
                                                        />
                                                        <rect
                                                          x="16.832"
                                                          y="13.4517"
                                                          width="2.27149"
                                                          height="2.27149"
                                                          transform="rotate(-40.2798 16.832 13.4517)"
                                                          fill="white"
                                                        />
                                                        <rect
                                                          x="16.5684"
                                                          y="16.6538"
                                                          width="2.27149"
                                                          height="2.27149"
                                                          transform="rotate(-40.2798 16.5684 16.6538)"
                                                          fill="white"
                                                        />
                                                      </svg>
                        
                                                      {/* SECOND 25px SVG */}
                                                      <svg
                                                        width="25"
                                                        height="25"
                                                        viewBox="0 0 25 25"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                      >
                                                        <rect
                                                          x="5.22852"
                                                          y="17.3296"
                                                          width="17.888"
                                                          height="2.27149"
                                                          transform="rotate(-40.2798 5.22852 17.3296)"
                                                          fill="white"
                                                        />
                                                        <rect
                                                          x="7.75781"
                                                          y="6.25635"
                                                          width="2.27149"
                                                          height="2.27149"
                                                          transform="rotate(-40.2798 7.75781 6.25635)"
                                                          fill="white"
                                                        />
                                                        <rect
                                                          x="10.959"
                                                          y="6.52002"
                                                          width="2.27149"
                                                          height="2.27149"
                                                          transform="rotate(-40.2798 10.959 6.52002)"
                                                          fill="white"
                                                        />
                                                        <rect
                                                          x="14.1562"
                                                          y="6.78516"
                                                          width="2.27149"
                                                          height="2.27149"
                                                          transform="rotate(-40.2798 14.1562 6.78516)"
                                                          fill="white"
                                                        />
                                                        <rect
                                                          x="17.0957"
                                                          y="10.25"
                                                          width="2.27149"
                                                          height="2.27149"
                                                          transform="rotate(-40.2798 17.0957 10.25)"
                                                          fill="white"
                                                        />
                                                        <rect
                                                          x="16.832"
                                                          y="13.4517"
                                                          width="2.27149"
                                                          height="2.27149"
                                                          transform="rotate(-40.2798 16.832 13.4517)"
                                                          fill="white"
                                                        />
                                                        <rect
                                                          x="16.5684"
                                                          y="16.6538"
                                                          width="2.27149"
                                                          height="2.27149"
                                                          transform="rotate(-40.2798 16.5684 16.6538)"
                                                          fill="white"
                                                        />
                                                      </svg>
                        
                                                    </span>
                                                  </span>
                        
                                                </Link>

                        {/* <button
                          className="btn-video subtle"
                          onClick={openVideo}
                          aria-label="Watch video"
                          style={{
                            background: "transparent",
                            border: "1px solid rgba(255,255,255,0.12)",
                            color: "white",
                            padding: "10px 14px",
                            borderRadius: 10,
                          }}
                        >
                          <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                            <svg width="18" height="18" viewBox="0 0 27 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M25.0957 13.268C26.429 14.0378 26.429 15.9623 25.0957 16.7321L3.95285 28.9389C2.61951 29.7087 0.952845 28.7465 0.952845 27.2069L0.952846 2.79319C0.952846 1.25359 2.61951 0.291337 3.95285 1.06114L25.0957 13.268Z" fill="white"/>
                            </svg>
                            Watch overview
                          </span>
                        </button> */}
                      </div>

                      {/* floating badges */}
                      <div className="hero-badges" style={{ display: "flex", gap: 12, marginTop: 10 }}>
                        {heroBadges.map((b, i) => (
                          <div
                            key={i}
                            className={`xb-badge xb-badge--${i}`}
                            style={{
                              display: "flex",
                              gap: 12,
                              alignItems: "center",
                              padding: "10px 14px",
                              borderRadius: 12,
                              background: i % 2 === 0 ? "linear-gradient(90deg, rgba(0,255,236,0.06), rgba(0,255,236,0.02))" : "linear-gradient(90deg, rgba(126,72,255,0.06), rgba(126,72,255,0.02))",
                              border: "1px solid rgba(255,255,255,0.04)",
                            }}
                          >
                            <img src={b.icon} alt="" style={{ width: 36 }} />
                            <div style={{ lineHeight: 1 }}>
                              <div style={{ fontWeight: 700 }}>{b.title}</div>
                              <div style={{ fontSize: 13, opacity: 0.8 }}>{b.content}</div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  {/* RIGHT - Floating card + image (sci-fi glass) */}
                  <div className="col-lg-5">
                    <div
                      className="floating-card xb-border"
                      style={{
                        background: "linear-gradient(180deg, rgba(255,255,255,0.03), rgba(255,255,255,0.01))",
                        padding: 22,
                        borderRadius: 14,
                        boxShadow: "0 20px 60px rgba(0,0,0,0.6)",
                        backdropFilter: "blur(6px)",
                      }}
                    >
                      <div style={{ display: "flex", gap: 14, alignItems: "center" }}>
                        <div style={{ width: 72, height: 72, borderRadius: 12, overflow: "hidden", flexShrink: 0 }}>
                          <img src={serviceImg} alt="service" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                        </div>

                        <div style={{ flex: 1 }}>
                          <h4 style={{ margin: 0, fontSize: 18 }}>Accelerate your Web3 roadmap</h4>
                          <p style={{ margin: "6px 0 0", fontSize: 13, opacity: 0.85 }}>
                            From architecture to audits — we launch resilient blockchain products that scale.
                          </p>
                        </div>
                      </div>

                      <div className="capsule-btn-group">
  <Link to="/project" className="capsule-btn left">
    See Projects
  </Link>

  <Link to="/contact" className="capsule-btn right">
    Talk to Expert
  </Link>
</div>

                    </div>

                    {/* subtle neon grid under card */}
                    <div style={{ marginTop: 16, display: "grid", gridTemplateColumns: "repeat(2,1fr)", gap: 8 }}>
                      <div className="stat-card xb-border" style={{ padding: 12, borderRadius: 10 }}>
                        <div style={{ fontSize: 22, fontWeight: 700 }}>200+</div>
                        <div style={{ fontSize: 12, opacity: 0.7 }}>Projects</div>
                      </div>
                      <div className="stat-card xb-border" style={{ padding: 12, borderRadius: 10 }}>
                        <div style={{ fontSize: 22, fontWeight: 700 }}>150+</div>
                        <div style={{ fontSize: 12, opacity: 0.7 }}>Experts</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* ================= WHY WEB3 (premium content block) ================= */}
            <section className="why-web3 section" style={{ padding: "48px 0" }}>
              <div className="container">
                <div className="row align-items-center">
                  <div className="col-lg-6">
                    <h3 className="details-content-title">Why adopt Web3 now?</h3>
                    <p style={{ color: "#fff", marginTop: 10 }}>
                      Decentralization unlocks new business models: trustless markets, programmable money, and community-driven products.
                      We help companies convert these opportunities into tangible revenue and long-term network effects.
                    </p>

                    <ul className="iconlist_block mt-20">
                      <li><span className="iconlist_text">Real asset ownership & provenance</span></li>
                      <li><span className="iconlist_text">Transparency & auditability of flows</span></li>
                      <li><span className="iconlist_text">New monetization with tokens & NFTs</span></li>
                    </ul>
                  </div>

                  <div className="col-lg-6">
                    <div className="card-grid" style={{ display: "grid", gridTemplateColumns: "repeat(2,1fr)", gap: 12 }}>
                      {devServices.slice(0,4).map((c, i) => (
                        <div
  key={i}
  className="xb-ser-item xb-border wow fadeInUp"
  data-wow-delay={`${i * 80}ms`}
  style={{
    padding: 22,
    borderRadius: 14,
    minHeight: 180,
    background: "linear-gradient(135deg, rgba(255,255,255,0.02), rgba(255,255,255,0.01))",
    display: "flex",
    flexDirection: "column",
    transition: "transform 0.25s ease, box-shadow 0.25s ease",
  }}
  onMouseEnter={(e) => {
    const el = e.currentTarget as HTMLElement;
    el.style.transform = "translateY(-10px)";
    el.style.boxShadow = "0 20px 60px rgba(0,0,0,0.25)";
  }}
  onMouseLeave={(e) => {
    const el = e.currentTarget as HTMLElement;
    el.style.transform = "translateY(0)";
    el.style.boxShadow = "none";
  }}
>
  {/* ICON + TITLE */}
  <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
    <div
      style={{
        width: 48,
        height: 48,
        borderRadius: 10,
        background: "linear-gradient(135deg, rgba(255,255,255,0.04), rgba(255,255,255,0.02))",
        display: "grid",
        placeItems: "center",
      }}
    >
      <img src={c.icon} alt="" style={{ width: 28 }} />
    </div>

    <h4 style={{ margin: 0 }}>{c.title}</h4>
  </div>

  {/* CONTENT */}
  <p
    style={{
      marginTop: 12,
      color: "#fff",
      lineHeight: 1.5,
      fontSize: 14,
      marginBottom: 0,
    }}
  >
    {c.content}
  </p>
</div>

                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </section>

            

            {/* ================= SERVICES GRID (equal height cards) ================= */}
            <section className="service pos-rel bg_img" style={{ padding: "48px 0" }}>
              <div className="container">
                <h2 className="details-content-title mt-30 mb-20">Services we provide</h2>

                <div className="row mt-none-30">
                  {devServices.map((svc, idx) => (
                    <div className="col-lg-4 col-md-6 mt-30" key={idx}>
                      <article
                        className="xb-ser-item xb-border wow fadeInUp"
                        data-wow-delay={`${idx * 60}ms`}
                        style={{
                          height: "320px",
                          display: "flex",
                          flexDirection: "column",
                          padding: 22,
                          borderRadius: 14,
                          transition: "transform 0.25s ease, box-shadow 0.25s ease",
                        }}
                        onMouseEnter={(e) => {
                          const el = e.currentTarget as HTMLElement;
                          el.style.transform = "translateY(-10px)";
                          el.style.boxShadow = "0 20px 60px rgba(0,0,0,0.25)";
                        }}
                        onMouseLeave={(e) => {
                          const el = e.currentTarget as HTMLElement;
                          el.style.transform = "translateY(0)";
                          el.style.boxShadow = "none";
                        }}
                      >
                        <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
                          <div style={{ width: 56, height: 56, borderRadius: 12, background: "linear-gradient(135deg, rgba(255,255,255,0.02), rgba(255,255,255,0.01))", display: "grid", placeItems: "center" }}>
                            <img src={svc.icon} alt="" style={{ width: 32 }} />
                          </div>

                          <h4 style={{ margin: 0 }}>{svc.title}</h4>
                        </div>

                        <p style={{ marginTop: 12, color: "#666", lineHeight: 1.6, marginBottom: "auto" }}>{svc.content}</p>

                        <div style={{ display: "flex", gap: 8, alignItems: "center", marginTop: 14 }}>
                          <Link to="/contact" className="xb-link" style={{ fontSize: 14, fontWeight: 600 }}>
                            Talk to us
                          </Link>
                        </div>
                      </article>
                    </div>
                  ))}
                </div>
              </div>
            </section>

            {/* ================= TECH STACK (Like Reference UI) ================= */}
<section className="tech-stack section" style={{ padding: "48px 0" }}>
  <div className="container">

    <h3 className="details-content-title">Web3 Technology Stack</h3>
    <p style={{ color: "#ccc", marginTop: 8, maxWidth: 700 }}>
      We use the right mix of blockchains, frameworks, smart contract tools, infra, and dev tools to build secure and scalable Web3 ecosystems.
    </p>

    <div style={{ marginTop: 32, display: "grid", gap: 28 }}>
      {techStack.map((t: any, i: number) => (
        <div
          key={i}
          className="wow fadeInUp"
          data-wow-delay={`${i * 50}ms`}
          style={{
            display: "flex",
            alignItems: "center",
            background: "#15121f",
            padding: 24,
            borderRadius: 18,
            border: "1px solid rgba(255,255,255,0.06)",
            gap: 24,
            minHeight: 160,
            transition: "0.25s ease",
          }}
          onMouseEnter={(e) => {
            const el = e.currentTarget as HTMLElement;
            el.style.transform = "translateY(-6px)";
            el.style.boxShadow = "0 12px 30px rgba(0,0,0,0.25)";
          }}
          onMouseLeave={(e) => {
            const el = e.currentTarget as HTMLElement;
            el.style.transform = "translateY(0)";
            el.style.boxShadow = "none";
          }}
        >

          {/* LEFT ICON PANEL */}
          <div
            style={{
              width: 110,
              height: "100%",
              minHeight: 110,
              background: "rgba(0,0,0,0.25)",
              borderRadius: 16,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 16,
            }}
          >
            <img
              src={t.icon}
              alt={t.title}
              style={{
                width: 64,
                height: 64,
                objectFit: "contain",
              }}
            />
          </div>

          {/* RIGHT CONTENT */}
          <div style={{ flex: 1 }}>
            <h4
              style={{
                fontSize: 20,
                color: "#fff",
                marginBottom: 16,
                fontWeight: 600,
              }}
            >
              {t.title}
            </h4>

            {/* TAG GRID */}
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: 10,
              }}
            >
              {t.items.map((item: string, index: number) => (
                <span
                  key={index}
                  style={{
                    padding: "6px 14px",
                    background: "rgba(255,255,255,0.1)",
                    borderRadius: 6,
                    fontSize: 14,
                    color: "#ddd",
                    whiteSpace: "nowrap",
                  }}
                >
                  {item}
                </span>
              ))}
            </div>
          </div>

        </div>
      ))}
    </div>
  </div>
</section>


            {/* ================= HIGHLIGHTS (feature cards) ================= */}
            <BrandSection />

            <section className="hero pos-rel bg_img" style={{ padding: "30px 0" }}>
              <div className="container">
                <h2 className="details-content-title title text-center wow fadeInUp" data-wow-delay="100ms">
                  Why clients pick us
                </h2>

                <p className="sub-title text-center wow fadeInUp" data-wow-delay="200ms" style={{ maxWidth: "900px", margin: "20px auto 30px" }}>
                  A mix of rigorous engineering, security-first culture and product sensibility — all tuned for Web3.
                </p>

                <div className="row mt-30">
                  {[feature1, feature2, feature3, feature4].map((ic, i) => (
                    <div className="col-lg-3 col-md-6 mt-30" key={i}>
                      <div className="xb-feature-item wow fadeInUp" data-wow-delay={`${300 + i * 100}ms`} style={{ height: "100%" }}>
                        <div className="xb-item--inner xb-border" style={{ padding: "30px 20px", minHeight: 260, display: "flex", flexDirection: "column" }}>
                          <span className="xb-item--icon" style={{ marginBottom: 16, display: "inline-block" }}>
                            <img src={ic} alt="icon" style={{ width: 64 }} />
                          </span>

                          <h3 className="xb-item--title" style={{ minHeight: 60 }}>
                            {i === 0 && "Strategy & Architecture"}
                            {i === 1 && "Secure Smart Contracts"}
                            {i === 2 && "User Centric dApps"}
                            {i === 3 && "Integration & Ops"}
                          </h3>

                          <p className="xb-item--content" style={{ marginTop: "auto", color: "#666" }}>
                            {i === 0 && "We model token economies and design robust protocol primitives to maximize long term value."}
                            {i === 1 && "Security practices baked in: audits, tests and hardened deployment patterns."}
                            {i === 2 && "Smooth wallet experiences, minimal friction UX and performant frontends."}
                            {i === 3 && "Monitoring, analytics and infra automation for resilient operations."}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </section>

            {/* ================= GALLERY / CASES ================= */}
            <section className="tech-stack section" style={{ padding: "36px 0" }}>
                <div className="container">
            <GallerySection />
            </div>
             </section>
            
          </main>

          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default Development;
